import apiClient from './client';
import { API_BASE_URL } from '../lib/constants';

export type DocumentoImpiantoTipo =
  | 'normativa'
  | 'scheda_tecnica'
  | 'autorizzazione'
  | 'altro';

export interface DocumentoImpianto {
  id: string;
  nome: string;
  descrizione: string | null;
  tipo: DocumentoImpiantoTipo;
  size_bytes: number;
  mime_type: string;
  uploaded_at: string;
  uploaded_by: string;
  uploaded_by_name: string;
}

export interface DocumentoImpiantoUpdate {
  nome?: string;
  descrizione?: string | null;
  tipo?: DocumentoImpiantoTipo;
}

export async function listDocumentiImpianto(
  tipo?: DocumentoImpiantoTipo,
): Promise<DocumentoImpianto[]> {
  const res = await apiClient.get('/api/documenti-impianto', {
    params: tipo ? { tipo } : {},
  });
  return res.data;
}

export async function uploadDocumentoImpianto(
  file: File,
  nome: string,
  descrizione: string | null,
  tipo: DocumentoImpiantoTipo,
): Promise<DocumentoImpianto> {
  const form = new FormData();
  form.append('file', file);
  form.append('nome', nome);
  form.append('tipo', tipo);
  if (descrizione != null && descrizione !== '') {
    form.append('descrizione', descrizione);
  }
  const res = await apiClient.post('/api/documenti-impianto', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

export async function updateDocumentoImpianto(
  id: string,
  payload: DocumentoImpiantoUpdate,
): Promise<DocumentoImpianto> {
  const res = await apiClient.patch(`/api/documenti-impianto/${id}`, payload);
  return res.data;
}

export async function deleteDocumentoImpianto(id: string): Promise<void> {
  await apiClient.delete(`/api/documenti-impianto/${id}`);
}

export function getDocumentoDownloadUrl(id: string): string {
  const base = API_BASE_URL || '';
  return `${base}/api/documenti-impianto/${id}/download`;
}
